import * as React from "react";
const ShieldVertical = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 94, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1.1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#ED0000", d: "M47.8 1.5H12.6v58h35.2z" })),
    React.createElement("mask", { id: "prefix__b", width: 94, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1.1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__b)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M83 1.5H47.8v58H83z" })),
    React.createElement("mask", { id: "prefix__c", width: 94, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1.1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__c)" },
        React.createElement("path", { fill: "#3F3F3F", d: "M47.8 59.5H83c0 19.3-15.9 35.2-35.2 35.2S12.6 78.8 12.6 59.5z" }))));
export default ShieldVertical;
//# sourceMappingURL=ShieldVertical.js.map